import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errorMessage } from "@/lib/api";

const FIELDS = [
  ["company_name", "Nome da empresa", "text"],
  ["responsible_name", "Responsável", "text"],
  ["phone", "Telefone / WhatsApp", "tel"],
  ["owner_email", "E-mail de login do responsável", "email"],
];

export const CompanyEditDialog = ({ company, onClose, onSaved }) => {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (company) setF({ company_name: company.company_name, responsible_name: company.responsible_name, phone: company.phone, owner_email: company.owner_email });
  }, [company]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.put(`/platform/companies/${company.id}`, f);
      toast.success("Empresa atualizada.");
      onSaved();
      onClose();
    } catch (err) { toast.error(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!company} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-slate-700 bg-slate-900 sm:max-w-md" data-testid="company-edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-bold">Editar empresa</DialogTitle>
          <DialogDescription>Se mudar o e-mail, o responsável passa a entrar com o novo e-mail e a mesma senha.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {FIELDS.map(([k, label, type]) => (
            <div key={k} className="space-y-1.5">
              <Label htmlFor={`ce_${k}`}>{label}</Label>
              <Input id={`ce_${k}`} type={type} required={k === "company_name" || k === "owner_email"} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })}
                className="h-10 bg-slate-950" data-testid={`company-edit-${k.replace("_", "-")}`} />
            </div>
          ))}
          <DialogFooter className="gap-2">
            <Button type="button" variant="ghost" onClick={onClose} data-testid="company-edit-cancel">Cancelar</Button>
            <Button type="submit" disabled={busy} className="rounded-full font-semibold" data-testid="company-edit-save">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salvar</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
